import { useTimesheet } from "./context";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import { Icon } from "components";
import { CIRCLE_CHECK_BIG } from "icons";
import { cn } from "utils";

export function ReviewStatus({ children, className, toolTipText, ...props }) {
  const {
    data: { areLogsReviewed },
  } = useTimesheet();

  if (typeof children === "function") {
    return children({ areLogsReviewed });
  }

  if (!areLogsReviewed) {
    return null;
  }

  return (
    <Tooltip {...props}>
      <TooltipTrigger>
        {children ? (
          children
        ) : (
          <Icon icon={CIRCLE_CHECK_BIG} className={className} />
        )}
      </TooltipTrigger>
      <TooltipContent>{toolTipText ? toolTipText : "Reviewed"}</TooltipContent>
    </Tooltip>
  );
}
